import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import ReactPlayer from 'react-player'
import {useEffect, useRef, useState} from "react";
import {isPc, savePageVisit, sendRequest} from "../static/js/common";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";


export const WorkDetail = ({}) => {

  const navigate = useNavigate()
  const [portfolio, setPortfolio] = useState()
  const params = useParams();
  const videoWrapperRef = useRef(null);
  const videoRef = useRef(null);

  const getPortfolioDetail = (id) => {
    sendRequest(`portfolio/portfolio/${id}/`, 'GET', null, data => {
      setPortfolio(data)
    })
  }

  useEffect(() => {
    if(params?.id) {
      getPortfolioDetail(params?.id)
    }
  }, [params?.id])

  useEffect(() => {
    window.scroll(0, 0)
    // videoWrapperRef?.current?.scrollIntoView()
  }, [portfolio]);

  const [mouseOver, setMouseOver] = useState(false);

  useEffect(() => {
    savePageVisit('Work상세')
  }, []);

  return (
    <div>
      <Header/>
      <div className={'black-bg'} style={{marginTop: 80}}>
        <div style={{padding: '3vw'}}>
          <div className={`${isPc ? 'flex-row-wo-center' : 'flex-column'}`}>
            <div className={`white bold notosans-black ${isPc ? '' : 'flex-row-wo-center'}`}
                 style={{fontSize: isPc ? 60 : 40}}>
              <div className={'flex-1'}>{portfolio?.name}</div>
              {!isPc ?
                <div className={'flex-end'} style={{paddingLeft: '3vw'}}>
                  <div onClick={() => navigate(-1)}
                       onMouseEnter={() => isPc && setMouseOver(true)}
                       onMouseLeave={() => isPc && setMouseOver(false)}
                  >
                    <img className={'icon-28'}
                         src={require('../assets/images/cancel.png')}/>
                  </div>
                </div>
                : null
              }
            </div>
            <div className={`flex-row ${isPc ? 'margin-top-32' : 'margin-top-8'} margin-left-10 flex-1`}>
              {portfolio?.tags?.map((item, index) => {
                return (
                  <div className={'red-badge notosans-black margin-right-8'}
                       style={{backgroundColor: item?.backgroundColor}}>{item?.name}</div>
                )
              })}
            </div>
            {isPc ?
              <div className={'flex-end'}>
                <div onClick={() => navigate(-1)}
                     onMouseEnter={() => isPc && setMouseOver(true)}
                     onMouseLeave={() => isPc && setMouseOver(false)}
                >
                  <img className={'icon-36'}
                       src={mouseOver ? require('../assets/images/cancel_red.png') : require('../assets/images/cancel_white.png')}/>
                </div>
              </div>
              : null
            }
          </div>
          {portfolio?.mainDetailImage ?
            <div style={{paddingTop: isPc ? '2vw' : '60px'}}>
              <img style={{width: '94vw', objectFit: 'contain'}} src={portfolio?.mainDetailImage}/>
            </div>
            :
            <div className={`${isPc ? 'margin-top-20' : 'margin-top-32'}`} style={{padding: '3vw'}}>
              <div ref={videoWrapperRef}>
                <ReactPlayer ref={videoRef} playing={true} width={'100%'} height={isPc ? '40vw' : '60vw'}
                             url={`https://www.youtube.com/watch?v=${portfolio?.youtubeId}`}/>
              </div>
            </div>
          }
          <div className={`${isPc ? 'flex-row margin-top-54' : 'flex-column margin-top-20'} `}>
            <div className={'flex-1 flex-column'}>
              <div className={'blur-white font-14'}>Client</div>
              <div className={'white margin-top-3 font-20'}>{portfolio?.client}</div>
              <div className={'blur-white font-14 margin-top-40'}>Services</div>
              <div className={'white margin-top-3 font-20'}>{portfolio?.services}</div>
            </div>
            <div className={`flex-1 ${isPc ? 'flex-end' : 'flex-start'}`}
                 style={{paddingRight: isPc ? '6vw' : 20, marginTop: isPc ? 0 : 40}}>
              <div className={'white font-14 pre-wrap'} style={{lineHeight: 1.8}}>
                {portfolio?.description}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}
